import { Fragment } from "react";
import { Link } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

/**
 * The order a fee is booked against, as a link to the order card. Shown wherever
 * someone decides about the fee — a wrong order picked by the requester must be
 * visible before "Akceptuj", not discovered after it.
 */
export function OfficialFeeOrderLink({
  orderId,
  orderNumber,
}: {
  orderId: string;
  orderNumber: string;
}) {
  // A contractor's order card lives in the portal; /orders/:id is the GK one.
  const isContractor = useAuthStore((s) => s.user?.role === "contractor");
  return (
    <Link
      to={isContractor ? `/contractor/orders/${orderId}` : `/orders/${orderId}`}
      // Rows and cards around it navigate to the fee on click.
      onClick={(e) => e.stopPropagation()}
      title="Otwórz kartę zamówienia"
      className="font-mono text-[var(--color-primary)] hover:text-[var(--color-primary-hover)] hover:underline"
    >
      {/* Break opportunities after each "/" — order numbers are long and the
          columns showing them are narrow. */}
      {orderNumber.split("/").map((part, i) => (
        <Fragment key={i}>
          {i > 0 && (
            <>
              /<wbr />
            </>
          )}
          {part}
        </Fragment>
      ))}
    </Link>
  );
}
